import { guid } from '@/utils/global/function'
import { handleKeepRoute } from '@/views/corporation/routes.js'

/**
 * 处理登录后路由
 * @param menus
 * @returns {Array}
 */
export const formatOtherRouters = (menus) => {
  let routers = []
  menus.forEach((menu) => {
    if (!menu) {
      return false
    }
    let { name, path, component, children, meta } = menu
    // 菜单第二层全是Layout,防止重复
    if (path === 'Layout') {
      name = guid()
      path = guid()
    }
    if (children && children instanceof Array) {
      children = formatOtherRouters(children)
    }
    meta = JSON.parse(JSON.stringify(meta || {}))
    let fmRouter = {
      name: name,
      path: path,
      component(resolve) {
        require([`@/views${component}.vue`], resolve)
      },
      children: children,
      meta: meta
    }
    routers.push(fmRouter)
  })
  return routers
}

/**
 * 根据用户信息处理路由
 */
export const handleRouteByUserRole = (routes, userInfo) => {
  let userRoutes = []
  routes.forEach((route) => {
    // 判断是否保留路由
    if (handleKeepRoute(route, userInfo)) {
      if (route.children && route.children.length > 0) {
        route.children = handleRouteByUserRole(route.children, userInfo)
      }
      userRoutes.push(route)
    }
  })
  return userRoutes
}

/**
 * 将store中取出的路由格式化
 * @param menus
 * @returns {[]}
 */
export const formatRoutes = (menus) => {
  let routers = []
  menus.forEach((menu) => {
    if (!menu) {
      return false
    }
    let { name, path, component, children, meta } = menu
    if (children && children instanceof Array) {
      children = formatRoutes(children)
    }
    meta = JSON.parse(JSON.stringify(meta || {}))
    let fmRouter = {
      name: name,
      path: path,
      component(resolve) {
        require([`@/views${(component || path)}.vue`], resolve)
      },
      children: children,
      meta: meta
    }
    routers.push(fmRouter)
  })
  return routers
}



// WEBPACK FOOTER //
// ./src/utils/router/other.js